import React from 'react'
import styles from './index.module.css'

const Line = () => {
  return (
    <div className={styles.lineC}>
        <div className={styles.line}/>
        <div className={styles.circkle}/>
    </div>
  )
}

export default Line